import { profileService } from '@/services/profiles'
import { aesToAco, acoToAES, validateObject } from '@/helpers/acoData'
const state = {
  encrypted: [],
  profiles: []
}

const actions = {
  getProfiles({ commit, dispatch }, payload) {
    profileService.getProfiles()
      .then(
        profiles => {
          commit(`setProfiles`, profiles)
        },
        error => {
          console.error(error)
          dispatch('alert/error', error.toString(), { root: true })
        }
      )

  },
  saveProfile({ commit, dispatch }, payload) { // 4 new & edit

  }
}

const mutations = {
  setProfiles(state, encrypted) {
    state.encrypted = encrypted
    let decrypted = encrypted.map(e => aesToAco(e))
    state.profiles = decrypted
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}